// extracted by mini-css-extract-plugin
export default {"main":"fb99a1c9a7","tit":"_7c3fd62894","maintitle":"_3ad9c69ae9","ylw":"_8e4b41cf0a","white":"fc5dd2ea2f","mv_title":"dc475a681a","mv_nc":"_7c1c6cd954","mv_in":"ce1aef0271"};